import { FormLayout } from '@/layouts'
import { PageWithLayout } from '@/lib/models/types/layouts'
import PasswordRecoveryView from '@/views/PasswordRecovery'

const PasswordRecoveryPage: PageWithLayout = () => <PasswordRecoveryView />

PasswordRecoveryPage.Layout = FormLayout

export default PasswordRecoveryPage
